import { jsx as _jsx } from "react/jsx-runtime";
import { RequireAuth } from '@/shared/modules/auth';
import { AccessLevelLayout } from './AccessLevelLayout';
const AuthorizedLayout = () => {
    return (_jsx(RequireAuth, { children: _jsx(AccessLevelLayout, {}) }));
};
export { AuthorizedLayout };
